import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as popupActions from 'react/redux/actions/popups';
import store from 'react/redux/store/store';

/**
 * Component that alerts if you click outside of it
 */
export default class OutsideAlerter extends Component {

	constructor(props) {
		super(props);

		this.wrapperRef = null;

		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	setWrapperRef(node) {
		this.wrapperRef = node;
	}

	getWrapperRef() {
		if(this.props.wrapperRef) {
			return this.props.wrapperRef;
		}
		else {
			return this.wrapperRef;
		}
	}

	/**
	 * Alert if clicked on outside of element
	 */
	handleClickOutside(event) {
		const { onExit } = this.props;
		let { excludeClicksTo } = this.props;
		if(!this.getWrapperRef() || this.getWrapperRef().contains(event.target)) {
			return;
		}
		if(excludeClicksTo) {
			if(!Array.isArray(excludeClicksTo)) {
				excludeClicksTo = [excludeClicksTo];
			}
			for(let excludedClick of excludeClicksTo) {
				if(excludedClick.contains(event.target)) {
					return;
				}
			}
		}
		if(onExit) {
			onExit();
		}
		else {
			store.dispatch(popupActions.clickedOutsidePopup());
		}
	}

	render() {
		if(this.props.wrapperRef || this.props.usesWrapper) {
			return this.props.children;
		}
		else {
			return <div ref={this.setWrapperRef}>{this.props.children}</div>;
		}
	}
}

OutsideAlerter.defaultProps = {
	onExit: null,
	wrapperRef: null,
	usesWrapper: false,// Used as an override to make sure the protective <div> does not get rendered
};

OutsideAlerter.propTypes = {
	children: PropTypes.element.isRequired,
};
